module.exports = __webpack_public_path__ + "img/customerservice.8571699b.svg";